var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46712 3.99978L5.12212 1.34478C5.26181 1.20426 5.34022 1.01417 5.34022 0.816028C5.34022 0.617889 5.26181 0.4278 5.12212 0.287278C5.0524 0.216982 4.96945 0.161186 4.87806 0.12311C4.78666 0.0850332 4.68863 0.0654297 4.58962 0.0654297C4.49061 0.0654297 4.39258 0.0850332 4.30119 0.12311C4.2098 0.161186 4.12684 0.216982 4.05712 0.287278L0.877122 3.46728C0.806826 3.537 0.75103 3.61995 0.712954 3.71135C0.674877 3.80274 0.655273 3.90077 0.655273 3.99978C0.655273 4.09879 0.674877 4.19682 0.712954 4.28821C0.75103 4.37961 0.806826 4.46256 0.877122 4.53228L4.05712 7.74978C4.1272 7.81929 4.21031 7.87428 4.30169 7.91161C4.39307 7.94893 4.49092 7.96785 4.58962 7.96728C4.68833 7.96785 4.78617 7.94893 4.87755 7.91161C4.96893 7.87428 5.05204 7.81929 5.12212 7.74978C5.26181 7.60926 5.34022 7.41917 5.34022 7.22103C5.34022 7.02289 5.26181 6.8328 5.12212 6.69228L2.46712 3.99978Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.6bdadf9c4afa731230aeee523bca0db9.svg";
export { ForwardRef as ReactComponent };